import { apiClient } from './api'

export interface UserInfo {
  id: string
  email: string
  first_name: string
  last_name: string
  display_name: string
}

export interface WebLogEntry {
  id: string
  type: string
  source?: string
  device_id?: string
  account_id?: string
  user_id?: string
  user?: UserInfo
  log_data?: string
  log_by?: string
  logged_by_user?: UserInfo
  user_agent?: string
  ip_addr?: string
  log_at: string
}

export interface WebLogsParams {
  type?: string
  source?: string
  user_id?: string
  device_id?: string
  account_id?: string
  days?: number
  page?: number
  page_size?: number
}

export const webLogService = {
  list: async (params?: WebLogsParams): Promise<WebLogEntry[]> => {
    const { data } = await apiClient.get<WebLogEntry[]>('/web-logs', { params })
    return data
  }
}
